import * as MutationTypes from './mutation-types'
import ReceitasService from '@/services/receitas-service'
import { NotAuthenticatedError } from '../../models/not-authenticated-error'

export default {
  state: {
    receitas: [],
    documento: null
  },

  getters: {
    getReceitas: (state) => state.receitas,
    getDocumento: (state) => state.documento
  },

  mutations: {
    [MutationTypes.GET_RECEITAS] (state, receitas) {
      state.receitas = receitas
    },
    [MutationTypes.SET_RECEITA_DOCUMENTO] (state, documento) {
      state.documento = documento
    }
  },

  actions: {
    async getReceitas ({ commit }) {
      commit('setLoadingState', true)

      await ReceitasService.getReceitas()
        .then((res) => {
          if (!res.ok && res.status >= 300) {
            if (res.status === 401) throw new NotAuthenticatedError()

            throw new Error(`HTTP error, status ${res.status}`)
          }
          return res.json()
        })
        .then((data) => {
          commit(MutationTypes.GET_RECEITAS, data)
          commit('setLoadingState', false)
        })
        .catch((err) => {
          commit('setLoadingState', false)
          throw err
        })
    },
    async getReceitaArquivo ({ commit }, dados) {
      commit('setLoadingState', true)

      await ReceitasService.getArquivo(dados.codigo, dados.prontuario)
        .then((res) => {
          if (!res.ok && res.status !== 200) {
            if (res.status === 401) throw new NotAuthenticatedError()
            throw new Error(`HTTP error, status ${res.status}`)
          }
          return res.data
        })
        .then((arquivo) => {
          commit(MutationTypes.SET_RECEITA_DOCUMENTO, arquivo)
          commit('setLoadingState', false)
        })
        .catch((err) => {
          commit('setLoadingState', false)
          throw err
        })
    }
  }
}
